

















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { AcgnFormTitle } from '@/components/';
import { openUrl } from '@/util';
import {
  AcgnTable,
} from '@acgn/herm/src/ui';
import {
  AcgnStaffCake
} from '@/components/statistic/components';
import AcgnPopFiledHistory from '../pop-field-history.vue';
import moment from 'moment';
const StatisticAction = namespace('desk/statistic').Action;
const StatisticGetter = namespace('desk/statistic').Getter;
const StaffGetter = namespace('desk/staff').Getter;
const CommGetter = namespace('desk/comm').Getter;
import { DatePicker } from 'element-ui';
@Component({
  components: {
    AcgnTable,
    AcgnFormTitle,
    AcgnPopFiledHistory,
    [DatePicker.name]: DatePicker,
    AcgnStaffCake
  }
})

/**
 * 任务情况-管理方
 */
export default class AcgnLinkDetail extends Vue {

  @Prop({ default: null }) public comicId: number | null; // 项目id
  @Prop({ default: '' }) public exportCode: string; // 导出权限码
  @Prop({ default: false }) public isUserLinks: boolean;

  @StatisticAction private getLinkStatistics: any;
  @StatisticAction private getUserLinks: any;
  @StatisticGetter private loadings: any; // loading
  @CommGetter private attributeData: any; // 公共类型
  @StaffGetter private departStaffList: any; // 团队成员列表
  private isInit: boolean = false;
  private searchForm: any = {
    project_id: (this as any).comicId,
    project_name: undefined,
    status: 4,
    times: [moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')]
  };

  // 审批状态列表
  private get linkStatus() {
    return this.attributeData.link_status || [];
  }
  private pickerOptions: any = {
    shortcuts: [{
        text: '今天',
        onClick: (picker: any) => {
          const s = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
          const e = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
          picker.$emit('pick', [s, e]);
        }
    }, {
        text: '昨天',
        onClick: (picker: any) => {
          const s = moment().add(-1, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss');
          const e = moment().add(-1, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');
          picker.$emit('pick', [s, e]);
        }
    }, {
        text: '前天',
        onClick: (picker: any) => {
          const s = moment().add(-2, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss');
          const e = moment().add(-2, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');
          picker.$emit('pick', [s, e]);
        }
    }, {
        text: '本周',
        onClick: (picker: any) => {
          const s = moment().startOf('week').format('YYYY-MM-DD HH:mm:ss');
          const e = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
          picker.$emit('pick', [s, e]);
        }
    }, {
        text: '上周',
        onClick: (picker: any) => {
          const week = moment().week(moment().week() - 1);
          const s = week.startOf('week').format('YYYY-MM-DD HH:mm:ss');
          const e = week.endOf('week').format('YYYY-MM-DD HH:mm:ss');
          picker.$emit('pick', [s, e]);
        }
    }, {
        text: '本月',
        onClick: (picker: any) => {
          const s = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
          const e = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
          picker.$emit('pick', [s, e]);
        }
    }, {
        text: '上月',
        onClick: (picker: any) => {
          const month = moment().month(moment().month() - 1);
          const s = month.startOf('month').format('YYYY-MM-DD HH:mm:ss');
          const e = month.endOf('month').format('YYYY-MM-DD HH:mm:ss');
          picker.$emit('pick', [s, e]);
        }
    }, {
        text: '过去7天',
        onClick: (picker: any) => {
          const s = moment().add(-7, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss');
          const e = moment().add(-1, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');
          picker.$emit('pick', [s, e]);
        }
    }, {
        text: '过去30天',
        onClick: (picker: any) => {
          const s = moment().add(-30, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss');
          const e = moment().add(-1, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');
          picker.$emit('pick', [s, e]);
        }
    }, {
        text: '过去90天',
        onClick: (picker: any) => {
          const s = moment().add(-90, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss');
          const e = moment().add(-1, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');
          picker.$emit('pick', [s, e]);
        }
    }, {
        text: '全部',
        onClick: (picker: any) => {
          picker.$emit('pick', ['1970-01-01', moment().format('YYYY-MM-DD HH:mm:ss')]);
        }
    }]
  };

  private tableConfig: any = {
    columns: [
      {
        label: '项目',
        prop: 'proname',
        render: (h: any, { row }: any) => (this as any).renderProjectName(row)
      },
      {
        label: '环节',
        prop: 'link_name'
      },
      {
        label: '审批状态',
        width: 80,
        render: (h: any, { row }: any) => (this as any).renderStauts(row)
      },
      {
        label: '件数',
        width: 80,
        prop: 'cell_number',
        render: (h: any, { row }: any) => (this as any).renderField(row)
      },
      {
        label: '单价',
        width: 80,
        prop: 'price'
      },
      {
        label: '总价',
        width: 100,
        render: (h: any, { row }: any) => {
          return row.price * row.cell_number;
        }
      },
      {
        label: '提交审批时间',
        width: 150,
        render: (h: any, { row }: any) => {
          return moment(row.submit_time).format('YYYY-MM-DD HH:mm:ss');
        }
      },
      {
        label: '审批完成时间',
        width: 150,
        render: (h: any, { row }: any) => {
          return moment(row.finish_time).format('YYYY-MM-DD HH:mm:ss');
        }
      }],
    data: []
  };

  private pageConfig: any = {
    currentPage: 1,
    pageSize: 20,
    total: 0
  }; // 分页数据

  private async created() {
    if (this.isUserLinks) {
     this.tableConfig.columns.unshift({
        label: '画手',
        prop: 'user_id',
        render: (h: any, { row }: any) => (this as any).renderProjectUser(row)
      });
    }
  }

  private renderStauts(row: any) {
    const statusItem = this.linkStatus.filter((item: any) => {
      return item.id === row.status;
    });
    return statusItem && statusItem[0] && statusItem[0].name;
  }

  private renderField(row: any) {
    if (Array.isArray(row.cell_number)) {
      const numValue = row.cell_number[0];
      let numDiff = row.cell_number[1];
      const classStyle = numDiff ? 'color--danger' : '';
      numDiff = numDiff ? numDiff : 0;
      return (
        <span class={classStyle}>{numValue + numDiff}{this.getUnitType(row.unit_type)}</span>
      );
    } else {
      return `${row.cell_number}${this.getUnitType(row.unit_type)}`;
    }
  }

  private renderProjectName(row: any) {
    return (<span onClick={() => this.projectNameSearch(row)}>{row.proname}</span>);
  }

  get getDepartStaffMap() {
    const map: any = {};
    const loopFn = (data: any) => {
      data.forEach((item: any) => {
        map[item.value] = item;
        if (item.children) {
          loopFn(item.children);
        }
      });
    };
    loopFn(this.departStaffList);
    return map;
  }

  private renderProjectUser(row: any) {
    const userInfo = this.getDepartStaffMap[row.user_id] || {};
    return userInfo.label || '';
  }

  private projectNameSearch(row: any) {
    // 必满重复筛选
    if (this.searchForm.project_name === row.proname) {
      return;
    }
    this.searchForm.project_name = row.proname;
    this.getLinkData(false);
  }

  private tableInitHandler({ page, size }: any) {
    this.pageConfig.currentPage = page;
    this.pageConfig.pageSize = size;
    this.getLinkData();
  }

  // table组件获取数据更新数据接口
  private async getLinkData(flag = true) {
    const options = this.getSearchOptions(flag);
    const { result: {list , pager} } = await (this.isUserLinks
    ? this.getUserLinks(options)
    : this.getLinkStatistics(options));
    this.pageConfig.total = pager.total_count;
    this.tableConfig.data = list;
  }

  private getSearchOptions(flag = true) {
    const { status: originStatus, project_name: originProjectName,
    project_id, times: originTimes, user_id} = this.searchForm;
    const times: any = originTimes || [];
    const status = originStatus || 0;
    const project_name = originProjectName || undefined;
    const {currentPage, pageSize} = this.pageConfig;
    const start_time = times[0] && moment(times[0]).format('YYYY-MM-DD HH:mm:ss');
    const end_time = times[1] && moment(times[1]).format('YYYY-MM-DD HH:mm:ss');
    const params = {
      user_id,
      status, project_name, project_id, page: (flag ? currentPage : 1), size: pageSize, start_time, end_time
    };
    return params;
  }

  private getUnitType(type = 1) {
    const unitType = this.unitTypes.filter((item: any) => item.id === type);
    return unitType[0].name;
  }

  private get unitTypes() {
    return this.attributeData.unit_type || [];
  }

  private submitHanddle() {
    // this.searchForm.project_name = undefined;
    this.getLinkData(false);
  }

  private exportExcel() {
    const downloadUrl = `/api/v1/link/${this.isUserLinks ? 'getuserlinks' : 'statistics' }?export=1`;
    openUrl(downloadUrl, Object.assign({}, this.getSearchOptions(), { size: 1000 }));
  }
}
